export default function getObject(key) {

    try {
        const objectRaw = localStorage.getItem(key);

        // if the item doesn't exist, return null
        if (!objectRaw) {
            return null;
        }

        return JSON.parse(objectRaw);
    } catch (error) {
        console.log(error);
    }
}